<template>
	<div class="main-content">
		<div class="center-body">
			<Nav />
			<div class="row" >
				<img src="../../assets/img/khalBanner.png" style="width: 100%;" />
			</div>
			<div class="mfty-box" style="background-color: #f0f0f0;height: 600px;">
				<div class="row ju-c al-c" style="color: #000;font-size: 32px;font-weight: bold;">
					客户案例
				</div>
				<div class="row ju-c al-c" style="margin-top: 20px;">
					<div class="item-no" style="width: 120px;height: 2px;background-color: #0fbee7;"></div>
				</div>
				<div style="width: 1100px;margin: 0 auto;">
					<div class="row" style="margin-top: 40px;">
						<div class="col">
							<div class="item-no" style="color: #000;font-size: 18px;">
								Maob-MES
							</div>
							<div class="item-no" style="color: #000;font-size: 22px;margin-top: 15px;">
								河北华通科技Maob-MES系统成功导入
							</div>
							<div class="item-no" style="color: #666;font-size: 16px;margin-top: 25px;line-height: 24px;text-align: left;">
								河北华通科技股份有限公司是国家级高新技术企业，公司于2015年成功在新三板挂牌上市，股票代码833105。公司主要业务包括：一、建筑智能化及系统集成；二、5G通信及大数据；三、空调及机电安装工程；四、节能及能源综合利用；五、 新能源及电力工程。
							</div>
							<div class="item-no" style="color: #666;font-size: 16px;margin-top: 25px;line-height: 24px;text-align: left;">
								公司已获得建筑智能化工程专业承包壹级资质、机电设备安装工程专业承包贰级资质、安全技术防范壹级资质、安全生产许可证书、ISO9000质量体系认证等多项证书，作为建筑智能化、机电设备安装及节能减排整体解决方案的提供商，公司客户遍布民用建筑、医院、学校、酒店、制药、冶炼、化工、电力、城市供热等各个行业。
							</div>
						</div>
						<div class="col-no" style="margin-left: 30px;justify-content: flex-end;">
							<img src="../../assets/img/khalD1.png" />
						</div>
					</div>
				</div>			
			</div>
			
			
			<div class="mfty-box" style="background-color: #fff;height: 980px;">
				
				<div style="width: 1100px;margin: 0 auto;margin-top: 100px;">
					<div class="row" style="margin-top: 40px;padding-bottom: 80px;border-bottom: 1px #ccc solid;">					
						<div class="col-no" style="justify-content: flex-start;width: 400px;">
							<div class="row">
								<div class="item-no" style="height: 24px;width: 3px;background-color: #0070FD;"></div>
								<div class="item" style="margin-left: 8px;color: #0070FD;font-size: 24px;font-weight: bold;">
									项目实施
								</div>
							</div>
						</div>
						<div class="col">
							<div class="item-no" style="color: #666;font-size: 16px;line-height: 24px;text-align: left;">
								通过本系统的实施，完成了生产计划制定、生产上料、生产过程追溯、生产检验、成品入库、IQC检验的物流及信息流过程管控。
							</div>
							<div class="item-no" style="color: #666;font-size: 16px;line-height: 24px;margin-top: 30px;text-align: left;">
								本次项目的实施提高了数据的准确性和采集效率、通过对产品的制造过程和质量信息进行实时采集，实现产品的制造过程追踪和产品与原料批次之间的双向追踪、实现对生产过程的精细化管理和控制、通过生产过程大量采集的现场作业数据，提供满足管理和业务的各类统计查询报表，并为将来的数据挖掘提供详实的数据。
							</div>
						</div>
					</div>
					<div class="row" style="margin-top: 40px;padding-bottom: 80px;">
						<div class="col-no" style="justify-content: flex-start;width: 400px;">
							<div class="row">
								<div class="item-no" style="height: 24px;width: 3px;background-color: #0070FD;"></div>
								<div class="item" style="margin-left: 8px;color: #0070FD;font-size: 24px;font-weight: bold;">
									收益分析
								</div>
							</div>
						</div>
						<div class="col">
							<div class="item-no" style="color: #666;font-size: 16px;line-height: 24px;text-align: left;">
								通过华通科技MES系统（生产执行系统）的实施，为进一步建立现代企业生产管理思想、理念打下基础，促进企业管理水平的提高；使顺络电子股份有限公司的生产管理业务信息化、自动化、数字化。
							</div>
							<div class="item-no" style="color: #666;font-size: 16px;line-height: 24px;margin-top: 30px;text-align: left;">
								通过华通科技MES系统项目的建设，推动生产管理管理的科学化，带动生产的现代化，实现工厂生产"数字化"，为建立"数字化工厂"，提高企业的市场竞争力打基础。提高客户满意度，建立卓有成效的物流与制造环节的监控-反馈-追溯系统。
							</div>
							<div class="item-no" style="color: #666;font-size: 16px;line-height: 24px;margin-top: 30px;text-align: left;">
								提供产品信息配置、工艺路线设计、生产订单管理、数据采集、物料防错、生产过程控制、预警和报警等各项功能。将车间物流透明化，解决在制品信息的准确性和及时性，为制造计划指令提供正确的反馈信息。
							</div>
							<div class="item-no" style="color: #666;font-size: 16px;line-height: 24px;margin-top: 30px;text-align: left;">
								建立完整的工单-产品-原材料的正反向追溯体系，建立产品质量同供应商和生产厂商的追踪关系,为客户服务及售后服务提供真实可靠的原始记录。实现全面的品质管理，建立车间生产实时监控环境，实现人、机、物、法、环的管理以及生产绩效分析。
							</div>
						</div>
					</div>
				</div>			
			</div>
			
			<Foot />
		</div>
	</div>
</template>

<script>
	import Nav from "./nav.vue";
	import Foot from "./foot.vue";

	export default {
		name: "App",
		components: {
			Nav,
			Foot
		},
		data() {
			return {
				curHeight: 0,
				mouseIndex:-1
			};
		},
		watch: {
			windowHeight(val) {
				let that = this;
				console.log("实时屏幕高度：", val, that.windowHeight);
			},
		},
		beforeMount() {

			var h = document.documentElement.clientHeight || document.body.clientHeight;

			this.curHeight = h; //减去页面上固定高度height
		},
		methods: {
			enter(index){
				this.mouseIndex=index
			},
			leave(){
				this.mouseIndex=-1
			}
		},
		mounted() {
			var that = this;
			window.onresize = () => {
				return(() => {
					window.fullHeight = document.documentElement.clientHeight;
					that.curHeight = window.fullHeight; // 高

				})()
			};
		},
	};
</script>
<style scoped>
	.main-content {
		min-height: 100%;
		width: 100%;
		margin: 0 auto;
		display: block;
		position: absolute;
		background: #f0f0f0;
		/* background: #f7f7f7; */
	}
	
	.center-body {
		margin: 0 auto;
	}
	
	.prduct-box {
		padding-top: 60px;
		width: 1200px;
		margin: 0 auto;
		position: relative;
	}
	.khal-tbox{
		height: 30px;
		background-color: #edf6ff;
		padding: 5px 15px;
		border-radius: 15px;
		color: #999;
	}
	.mfty-box{
		height: 600px;
		background-color: #fff;
		padding-top: 60px;
		text-align: center;
	}
	
</style>